import React from "react";
import { Link } from "react-router-dom";
import {
  IoIosWallet,
  IoIosArrowRoundForward,
  IoIosCheckmark,
  IoIosCloud,
  IoIosPricetag,
  IoIosFlash,
  IoIosCart,
  IoIosCafe,
  IoLogoWhatsapp,
} from "react-icons/io";
import BulbMark from "../../component/BulbMark";
import { useConfig } from "../../api";
import { FormatNumber } from "../../helpers";
import "./Landing.css";

const features = [
  {
    icon: <IoIosWallet />,
    title: "Multi-wallet",
    sub: "Pribadi, usaha, tunai. Pisah tanpa ribet.",
  },
  {
    icon: <IoIosPricetag />,
    title: "Tag pintar",
    sub: "Beri label sekali, lihat pola seumur hidup.",
  },
  {
    icon: <IoIosFlash />,
    title: "Pencarian cepat",
    sub: "Filter tanggal, deskripsi, wallet, tag.",
  },
  {
    icon: <IoIosCloud />,
    title: "Cloud sync",
    sub: "Data aman di awan. Akses dari device manapun.",
  },
];

const Landing = () => {
  const { data: config } = useConfig();
  const isDev =
    typeof process !== "undefined" && process.env.REACT_APP_DEV_USER_ID;

  // In dev (DEV_USER_ID bypass), the app is already authed — drop into home.
  // In production, send new visitors to signup and let the login link cover
  // returning users.
  const ctaHref = isDev ? "/" : "/signup";

  const walletLimit = config?.walletLimit ?? 3;
  const subscriptionPrice = config?.subscriptionPrice ?? 10000;

  return (
    <div className="lp">
      <div className="lp__inner">
        <header className="lp__header">
          <span className="lp__brand">
            <BulbMark size={28} />
            cashflow
          </span>
          <span className="lp__tag">v2 · 2026</span>
        </header>

        <section className="lp__hero">
          <div className="lp__hero-mark">
            <BulbMark size={128} glow />
          </div>
          <h1 className="lp__hero-title">
            Catat. Pantau. <strong>Mengerti.</strong>
          </h1>
          <p className="lp__hero-sub">
            Pencatat keuangan untuk hidup yang nggak selalu rapi.
          </p>
          <Link to={ctaHref} className="lp__cta">
            Mulai Gratis
            <IoIosArrowRoundForward size="1.4em" />
          </Link>
          <span className="lp__cta-foot">
            Tanpa kartu kredit · Sinkron otomatis
          </span>
        </section>

        <div className="lp__stack" aria-hidden="true">
          <div className="lp__mock-card">
            <span className="lp__mock-icon lp__mock-icon--income">
              <IoIosWallet />
            </span>
            <div className="lp__mock-body">
              <div className="lp__mock-label">Gaji bulan Mei</div>
              <div className="lp__mock-meta">
                01 Mei
                <span className="lp__mock-meta-tag">gaji</span>
              </div>
            </div>
            <span className="lp__mock-amount lp__mock-amount--income">
              +8.500.000
            </span>
          </div>
          <div className="lp__mock-card">
            <span className="lp__mock-icon lp__mock-icon--food">
              <IoIosCafe />
            </span>
            <div className="lp__mock-body">
              <div className="lp__mock-label">Kopi pagi</div>
              <div className="lp__mock-meta">
                11 Mei
                <span className="lp__mock-meta-tag">makan</span>
              </div>
            </div>
            <span className="lp__mock-amount lp__mock-amount--expense">
              -25.000
            </span>
          </div>
          <div className="lp__mock-card">
            <span className="lp__mock-icon lp__mock-icon--expense">
              <IoIosCart />
            </span>
            <div className="lp__mock-body">
              <div className="lp__mock-label">Belanja groceries</div>
              <div className="lp__mock-meta">
                07 Mei
                <span className="lp__mock-meta-tag">belanja</span>
              </div>
            </div>
            <span className="lp__mock-amount lp__mock-amount--expense">
              -120.000
            </span>
          </div>
        </div>

        <section className="lp__features">
          {features.map((f, i) => (
            <article className="lp__feature" key={i}>
              <span className="lp__feature-icon">{f.icon}</span>
              <h3 className="lp__feature-title">{f.title}</h3>
              <p className="lp__feature-sub">{f.sub}</p>
            </article>
          ))}
        </section>

        <section className="lp__pricing">
          <div className="lp__section-title">Sederhana juga harganya</div>
          <div className="lp__price-grid">
            <div className="lp__price">
              <div className="lp__price-name">Gratis</div>
              <div className="lp__price-amount">Rp 0</div>
              <div className="lp__price-period">selamanya</div>
              <ul className="lp__price-list">
                <li>
                  <IoIosCheckmark size="1.3em" /> Catatan tak terbatas
                </li>
                <li>
                  <IoIosCheckmark size="1.3em" /> {walletLimit} wallet
                </li>
                <li>
                  <IoIosCheckmark size="1.3em" /> Tag & pencarian
                </li>
              </ul>
            </div>
            <div className="lp__price lp__price--pro">
              <div className="lp__price-badge">Direkomendasikan</div>
              <div className="lp__price-name">Pro</div>
              <div className="lp__price-amount">
                Rp {FormatNumber(subscriptionPrice)}
              </div>
              <div className="lp__price-period">per bulan</div>
              <ul className="lp__price-list">
                <li>
                  <IoIosCheckmark size="1.3em" /> Semua dari Gratis
                </li>
                <li>
                  <IoIosCheckmark size="1.3em" /> Wallet tak terbatas
                </li>
                <li>
                  <IoIosCheckmark size="1.3em" /> Prioritas fitur
                </li>
              </ul>
            </div>
          </div>
        </section>

        <section className="lp__final">
          <h2 className="lp__final-title">
            Siap pegang kendali <strong>uangmu?</strong>
          </h2>
          <Link to={ctaHref} className="lp__cta">
            Mulai Sekarang
            <IoIosArrowRoundForward size="1.4em" />
          </Link>
        </section>

        <footer className="lp__footer">
          <span>© 2026 zcode</span>
          <a
            href="https://wa.me/6285776556212"
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoWhatsapp /> WhatsApp
          </a>
        </footer>
      </div>
    </div>
  );
};

export default Landing;
